import {AfterViewInit, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

import {Listing} from '../../../../core/models/listing';
import {TorontoListingsService} from '../../services/toronto-listings.service';
import {SEOService} from '../../../../core/services/seo.service';
import {NavigationComponent} from '../../../../shared/components/navigation/navigation.component';
import {TorontoListingsSearchComponent} from '../search-filter/toronto-listings-search.component';
import {BaseDashboardComponent} from "../../../../shared/components/base-dashboard/base-dashboard.component";
import {LISTINGS_SERVICE_TOKEN} from "../../../../core/services/listings-service.token";


import {Globals} from '../../../../core/services/globals';

import {BsModalService} from 'ngx-bootstrap/modal';

import {TrackingService} from '../../../../core/services/tracking.service';
// GA4 Analytics Tracking
import {DataLayerService} from '../../../../core/services/data-layer.service';

import {NgbdCarouselConfigComponent} from '../../../../shared/components/carousel/carousel-config';
import {CommonModule, CurrencyPipe, DOCUMENT} from '@angular/common';
import {BreakpointObserver} from '@angular/cdk/layout';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    NavigationComponent,
    RouterModule,
    NgbdCarouselConfigComponent,
    TorontoListingsSearchComponent,

  ],
  providers: [
    CurrencyPipe,  // <-- Add this if needed
    {provide: LISTINGS_SERVICE_TOKEN, useClass: TorontoListingsService}
  ],
  standalone: true,
  selector: 'my-toronto-dashboard',
  templateUrl: './toronto-dashboard.component.html',
  styleUrls: ['./toronto-dashboard.component.css'],
})

export class TorontoDashboardComponent extends BaseDashboardComponent implements AfterViewInit, OnInit, OnDestroy {
  constructor(
    protected override router: Router,
    protected override activatedRoute: ActivatedRoute,
    protected override http: HttpClient,
    protected override renderer: Renderer2,
    protected override listingsService: TorontoListingsService,
    protected override SEOService: SEOService,
    public override globals: Globals,
    protected override elementRef: ElementRef,
    protected override modalService: BsModalService,
    protected override dataLayerService: DataLayerService,
    protected override trackingService: TrackingService,
    protected override breakpointObserver: BreakpointObserver,
    protected override sanitizer: DomSanitizer,
    @Inject(DOCUMENT) protected override document: Document,
    protected override zone: NgZone
  ) {
    super(
      router,
      activatedRoute,
      http,
      renderer,
      listingsService,
      SEOService,
      globals,
      elementRef,
      modalService,
      dataLayerService,
      trackingService,
      breakpointObserver,
      sanitizer,
      document,
      zone
    );
  }

  ngOnInit(): void {
    console.log('ngOnInit: Dashboard');
    // Initialize the base dashboard functionality
    this.initializeBaseDashboard();

    // override the registration status to not require registration
    this.globals.isRegisteredBln = '1';

    // Detect screen changes
    this.setupBreakpointObserver();

    // Perform shared initialization tasks
    this.initializeSharedData();

    // load the initial page data
    this.initializePageContent();

    // Allow child classes to customize their behavior
    this.initDashboard();
  }


  ngAfterViewInit(): void {
    const header = document.querySelector('.navbar-default');
    if (header != null) {
      header.classList.remove('navbar-shrink');
    }
    setTimeout(() => this.setScrollTo('resultsList'));
  }


  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }


  protected override initDashboard(): void {
    console.log('init Toronto Dashboard');
    console.log('Path: ' + this.router.url);
    this.setGlobalSearchMin();
    this.handleDistrictDefaults();
    // Reset the previousRouteStr on page load
    this.resetPreviousRoute();
    console.log('District Loading: ' + this.globals.districtList);
    // fork, if the listings haven't been already loaded then load them up
    if (this.globals.listings.length === 0) {
      this.fetchListings();
    } else {
      this.listings = this.globals.listings;
      this.selectedListing = this.globals.selectedListing;
      this.isSelectedBln = true;
    }

    return;
    // fork, if the user has registered then set the property variable
    if (this.globals.isRegisteredBln === '1') {
      this.isRegisteredBln = '1';
    }
    // disable the registration requirment
    // this.isRegisteredBln = true;
    // console.log('Registration Status: ' + this.isRegisteredBln);
  }

  protected override onListingsFetched(listings: Listing[]): void {
    this.listings = listings;
    this.globals.listings = listings;
    console.log('Listings fetched:', listings);
    if (listings && listings.length > 0) {
      this.gotoDetail(listings[0]); // Navigate to the first listing
    } else {
      console.warn('No listings found.');
    }
  }
}
